
    <spaq-wait-password (onMailRequest)="sendConfirmationLink($event)"
                        [status]="success$ | async"
                        [form]="form$ | async"
                        [pending]="pending$ | async"></spaq-wait-password>
  


// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/forgot-password/containers/wait-password-page.component.ts.WaitPasswordPageComponent.html